import { Module } from 'vuex';

import * as actions from './actions';
export * from './types';

export const schedule: Module<unknown, unknown> = {
  namespaced: true,
  actions,
};

export type ScheduleActions = typeof actions;
